export const removeFrame = (v) => $.frame.remove(v);
